import { Injectable } from '@angular/core';
import { FileInfoType, FileListService } from '@schoolbelle/api/file';
import { get } from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class TextEditorService {
  private objectURLFileMap = new Map<string, File>();
  private _editor;

  set editor(obj) {
    this._editor = obj;
  }

  get editor() {
    return this._editor;
  }


  private getFileElementInEditor (editor:any, file:Blob|FileInfoType):HTMLAnchorElement|HTMLImageElement|HTMLSpanElement {
    let id:string;
    if (file instanceof Blob) {
      const url = get(Array.from(this.objectURLFileMap.entries()).find(([url, f])=>f === file), '0');
      id = this.getIdFromSrc(url);
    } else {
      id = ''+file.file_id;
    }
    if (!id) return null;
    return editor.$el[0].querySelector(`#file${id}`);

  }
  assignIdToInsertedFileElement (el:HTMLImageElement|HTMLAnchorElement|HTMLSpanElement):void {
    if (el instanceof HTMLImageElement) {
      const id = this.getIdFromSrc(el.src);
      el.setAttribute('id', `file${id}`);
    }
    else if (el instanceof HTMLAnchorElement) {
      const id = this.getIdFromSrc(el.href);
      el.setAttribute('id', `file${id}`);
    }
    else if (el instanceof HTMLSpanElement) {
      const iframe = el.querySelector('iframe');
      if (iframe) {
        const id = iframe.src.split('/').pop();
        el.setAttribute('id', `file${id}`);
      }  
    }
  }

  insertLink (editor:any, list:FileListService, file:File) {
    const url = URL.createObjectURL(file);
    this.insertFileIntoFilelist(list, url, file);
    editor.file.insert(url, file.name);
  } 
  insertImage (editor:any, list:FileListService, file:File) {
    const url = URL.createObjectURL(file);
    this.insertFileIntoFilelist(list, url, file);
    editor.image.insert(url, false); // sanition should be set to false for objectURL to work.
  } 
  insertVideo (editor:any, list:FileListService, file:File) {
    const url = URL.createObjectURL(file);
    this.insertFileIntoFilelist(list, url, file);
    editor.video.insert(
      // `<iframe width="640" height="360" src="v?o=${url}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`,
      `<iframe src="v?o=${url}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`,
      false
    );
  } 
  deleteFileElementInEditor (editor:any, file:Blob|FileInfoType):void {
    const el = this.getFileElementInEditor(editor, file);
    if (!el) return;
    // if (el instanceof HTMLAnchorElement) {
    //   editor.selection.setAtEnd(el); 
    //   editor.selection.restore();
    //   editor.link.remove()
    // } else if (el instanceof HTMLImageElement) {
    //   editor.image.remove($(el))
    // } else if (el instanceof HTMLSpanElement) {
    //   console.debug(el, el.querySelector('iframe'));
    //   editor.selection.setAtStart(el.querySelector('iframe')); 
    //   editor.selection.restore();
    //   console.debug(editor.video.get($(el)));
    //   editor.video.remove($(el));
    // }    
    el.remove();
    editor.events.trigger('contentChanged');
  }
  updateFileElementInEditor (editor:any, old:Blob|FileInfoType, n:Blob|FileInfoType):void {
    const el = this.getFileElementInEditor(editor, old);
    if (!el) return;
    const url = n instanceof Blob ? get(Array.from(this.objectURLFileMap.entries()).find(([url, f])=>f === n), '0') : n.url.replace(/[^\/]+$/, '');

    if (el instanceof HTMLAnchorElement) {
      el.href = url;
    } else if (el instanceof HTMLImageElement) {
      el.src = url;
    } else if (el instanceof HTMLSpanElement) {
      el.querySelector('iframe').src = `https://schoolbell-e.com/main/v?u=${url}`;
    }    
    editor.events.trigger('contentChanged');
  }
  private getIdFromSrc (url:string):string {
    return typeof url === 'string' && url.split('/').pop().split(':').pop();
  }

  insertFileIntoFilelist(list:FileListService, url: string, file: File) {
    const id = this.getIdFromSrc(url);
    // list.push(file, false);
    list.push(file);
    this.objectURLFileMap.set(id, file);
  }
  deleteFileFromFilelist(list:FileListService, url:string) {
    const id = this.getIdFromSrc(url);
    const file = this.objectURLFileMap.get(id);
    if (file) {
      URL.revokeObjectURL(url);
      this.objectURLFileMap.delete(id);
      list.remove(file);
    } else {
      const file = list.list.find(f => (f instanceof Blob ? f === file : f.url === url));
      if (file) list.remove(file);
    }
  }





}
